var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      attrs: {
        value: _vm.showModal,
        title: "Merge Schools",
        size: "lg",
        backdrop: false
      },
      on: { input: _vm.updateShowModal }
    },
    [
      _vm.currentStep === "selection"
        ? _c("div", { staticClass: "merge-schools-form" }, [
            _vm.errorMessage
              ? _c("div", { staticClass: "alert alert-danger" }, [
                  _c("i", { staticClass: "fa fa-exclamation-circle" }),
                  _vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { staticClass: "control-label" }, [
                _c("strong", [_vm._v("School to Keep")])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "help-block" }, [
                _vm._v(
                  "\n        All users will be moved to this school\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.targetSchoolUuid,
                      expression: "targetSchoolUuid"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.targetSchoolUuid = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.clearError
                    ]
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [
                    _vm._v("-- Select School to Keep --")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.availableSchools, function(school) {
                    return _c(
                      "option",
                      { key: school.uuid, domProps: { value: school.uuid } },
                      [
                        _vm._v(
                          "\n          " + _vm._s(school.name) + "\n        "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { staticClass: "control-label" }, [
                _c("strong", [_vm._v("School to Remove")])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "help-block" }, [
                _vm._v(
                  "\n        This school will be deleted after users are moved\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.sourceSchoolUuid,
                      expression: "sourceSchoolUuid"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.sourceSchoolUuid = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.clearError
                    ]
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [
                    _vm._v("-- Select School to Remove --")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.availableSchools, function(school) {
                    return _c(
                      "option",
                      {
                        key: school.uuid,
                        attrs: {
                          disabled: school.uuid === _vm.targetSchoolUuid
                        },
                        domProps: { value: school.uuid }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(school.name) + "\n        "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep === "confirmation"
        ? _c("div", { staticClass: "merge-schools-confirmation" }, [
            _c("div", { staticClass: "alert alert-warning" }, [
              _c("h4", [
                _c("i", { staticClass: "fa fa-warning" }),
                _vm._v(" Confirm School Merge")
              ]),
              _vm._v(" "),
              _c("p", [_c("strong", [_vm._v("This action cannot be undone.")])])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "merge-summary" }, [
              _c("table", { staticClass: "table table-bordered" }, [
                _c("tbody", [
                  _c("tr", [
                    _c("td", [_c("strong", [_vm._v("School to Keep:")])]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.targetSchool && _vm.targetSchool.name))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_c("strong", [_vm._v("School to Remove:")])]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.sourceSchool && _vm.sourceSchool.name))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", { staticClass: "info" }, [
                    _c("td", [_c("strong", [_vm._v("Users to Move:")])]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.userCount) + " user(s)")])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v(_vm._s(_vm.userCount))]),
              _vm._v(" user(s) will be moved from \n      "),
              _c("strong", [
                _vm._v(_vm._s(_vm.sourceSchool && _vm.sourceSchool.name))
              ]),
              _vm._v(" to \n      "),
              _c("strong", [
                _vm._v(_vm._s(_vm.targetSchool && _vm.targetSchool.name))
              ]),
              _vm._v(".\n    ")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("\n      After the merge, "),
              _c("strong", [
                _vm._v(_vm._s(_vm.sourceSchool && _vm.sourceSchool.name))
              ]),
              _vm._v(" will be deleted.\n    ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep === "processing"
        ? _c("div", { staticClass: "merge-schools-processing" }, [
            _c("div", { staticClass: "alert alert-info text-center" }, [
              _c("i", { staticClass: "fa fa-spinner fa-spin fa-2x" }),
              _vm._v(" "),
              _c("p", { staticClass: "lead" }, [_vm._v("Merging schools...")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Please wait while we move users and delete the source school."
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep === "success"
        ? _c("div", { staticClass: "merge-schools-success" }, [
            _c("div", { staticClass: "alert alert-success" }, [
              _c("h4", [
                _c("i", { staticClass: "fa fa-check-circle" }),
                _vm._v(" Schools Merged Successfully")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.userCount) +
                    " user(s) have been moved from \n        "
                ),
                _c("strong", [
                  _vm._v(_vm._s(_vm.sourceSchool && _vm.sourceSchool.name))
                ]),
                _vm._v(" to \n        "),
                _c("strong", [
                  _vm._v(_vm._s(_vm.targetSchool && _vm.targetSchool.name))
                ]),
                _vm._v(".\n      ")
              ]),
              _vm._v(" "),
              _vm.schoolDeleted
                ? _c("p", [
                    _vm._v("\n        The school "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.sourceSchool && _vm.sourceSchool.name))
                    ]),
                    _vm._v(" has been deleted.\n      ")
                  ])
                : _c("p", { staticClass: "text-warning" }, [
                    _c("i", { staticClass: "fa fa-warning" }),
                    _vm._v("\n        The school "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.sourceSchool && _vm.sourceSchool.name))
                    ]),
                    _vm._v(" could not be deleted automatically.\n      ")
                  ]),
              _vm._v(" "),
              _vm.removalErrors && _vm.removalErrors.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "alert alert-warning",
                      staticStyle: { "margin-top": "15px" }
                    },
                    [
                      _c("h5", [
                        _c("i", { staticClass: "fa fa-exclamation-triangle" }),
                        _vm._v(" Removal Issues:")
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "mb-0" },
                        _vm._l(_vm.removalErrors, function(error) {
                          return _c("li", { key: error }, [
                            _vm._v(_vm._s(error))
                          ])
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep === "error"
        ? _c("div", { staticClass: "merge-schools-error" }, [
            _c("div", { staticClass: "alert alert-danger" }, [
              _c("h4", [
                _c("i", { staticClass: "fa fa-exclamation-circle" }),
                _vm._v(" Merge Failed")
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.errorMessage))])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _vm.currentStep === "selection"
          ? _c(
              "button",
              {
                staticClass: "btn btn-default",
                attrs: { type: "button" },
                on: { click: _vm.onCancel }
              },
              [_vm._v("\n      Cancel\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.currentStep === "selection"
          ? _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button", disabled: !_vm.canProceed },
                on: { click: _vm.showConfirmation }
              },
              [_vm._v("\n      Next\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.currentStep === "confirmation"
          ? _c(
              "button",
              {
                staticClass: "btn btn-default",
                attrs: { type: "button" },
                on: { click: _vm.backToSelection }
              },
              [_vm._v("\n      Back\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.currentStep === "confirmation"
          ? _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: { type: "button" },
                on: { click: _vm.executeMerge }
              },
              [
                _c("i", { staticClass: "fa fa-compress" }),
                _vm._v("\n      Confirm Merge\n    ")
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.currentStep === "success" || _vm.currentStep === "error"
          ? _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.closeModal }
              },
              [_vm._v("\n      Close\n    ")]
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }